import { Component, Input, Output, EventEmitter } from '@angular/core';
import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';

// UTILS
import { trackByControlValue, trackById } from '../../../shared/util/track-by.util';

@Component({
  selector: 'lum-rfq-line-items-table',
  templateUrl: './rfq-line-items-table.component.html',
  styleUrls: ['./rfq-line-items-table.component.scss'],
})
export class RfqLineItemsTableComponent {
  @Input()
  rfqs :any[] | null = [];

  @Input()
  form :UntypedFormGroup;

  @Input()
  loading :boolean = false;

  @Output()
  addSelectedLineItems = new EventEmitter<any>();

  enableBulkQtyUpdate :boolean = false;

  trackByControlValue = trackByControlValue;
  trackById = trackById;

  onSelectRfq(abstractControl :AbstractControl) :void {
    const item = abstractControl as UntypedFormControl;
    item.get('selected')?.patchValue((item.value.selected = !item.value.selected));

    if (item.value.selected) {
      this.selectedLineItemsFormArray.push(item);
    } else {
      const index = this.selectedLineItemsFormArray.value.findIndex(
        (rfq :any) => rfq.id === item.value?.id,
      );
      this.selectedLineItemsFormArray.removeAt(index);
    }
  }

  onSelectAllSkus(event :MatCheckboxChange) :void {
    this.lineItemsFormArray.controls.forEach((rfq :any) => {
      rfq.get('selected').patchValue(event.checked);

      if (event.checked) {
        const selected = this.selectedLineItemsFormArray.value.some(
          (selectedRfq :any) => selectedRfq.id === rfq.value?.id,
        );
        if (!selected) {
          this.selectedLineItemsFormArray.push(rfq);
        }
      } else {
        const index = this.selectedLineItemsFormArray.value.findIndex(
          (selectedRfq :any) => selectedRfq.id === rfq.value?.id,
        );
        this.selectedLineItemsFormArray.removeAt(index);
      }
    });
  }

  onSetBulkQty(event :any) :void {
    this.lineItemsFormArray.controls.forEach((rfq :any) => {
      if (rfq.get('selected').value) {
        rfq.get('quantity').patchValue(event.target.value);
      }

      this.selectedLineItemsFormArray.controls.forEach((selectedRfq :any) => {
        selectedRfq.get('quantity').patchValue(parseInt(event.target.value));
      });
    });
  }

  get lineItemsFormArray() :UntypedFormArray {
    return this.form.get('rfqs') as UntypedFormArray;
  }
  get selectedLineItemsFormArray() :UntypedFormArray {
    return this.form.get('lineItems') as UntypedFormArray;
  }
}
